import { Typography, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateSelectedDate } from 'store/schedule/schedulePageOperation';
import { format, isSameDay } from 'date-fns';
import styles from './styles';

const ScheduleMobileHeader = ({ classes }) => {
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate();
  const selectedDate = useSelector((state) => state.schedule.selectedDate);

  const isToday = () => {
    if (!selectedDate) return true;
    return isSameDay(new Date(), new Date(selectedDate));
  };

  const setToday = () => {
    const date = new Date();
    dispatch(updateSelectedDate(date));

    const arr = location.pathname.split('/').filter(p => !!p);
    if (/(\d{4}-\d{2}-\d{2})$/.test(location.pathname)) arr[arr.length - 1] = format(date, 'yyyy-MM-dd');
    else arr.push(format(date, 'yyyy-MM-dd'))
    navigate('/' + arr.filter(p => !!p).join('/'));
  };

  return (
    <>
      <Grid container justifyContent="space-between" style={{ padding: '0 15px' }}>
        <Typography variant="h3">Schedule</Typography>
        <Button
          className={classes.todayButton}
          variant="contained"
          color="secondary"
          onClick={setToday}
          disabled={isToday()}
          disableTouchRipple
        >
          Today
        </Button>
      </Grid>
    </>
  );
};

export default withStyles(styles)(ScheduleMobileHeader);
